module.exports = __webpack_public_path__ + "img/ire-flag.1d1ee510.svg";